module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_1.abe87f40.png";